import {
  DefaultCharge,
  DefaultChargeCreation,
  DefaultChargeResource,
  DevicesTypeResource,
  FleetSettings,
  FleetSettingsResource,
} from 'services/resources';
import request from '../../request';

/**
 * Returns fleet settings
 */
export function settings() {
  return request<FleetSettingsResource>('fleet/settings/', {
    method: 'GET',
  });
}

export function patchSettings(id: number, fleetSettings: Partial<FleetSettings>) {
  const sanitizedSettings = { ...fleetSettings };
  // @ts-expect-error Property 'alerts' does not exist on type '{ allowTaxesPerAgreement: ... Remove this comment to see the full error message
  delete sanitizedSettings.alerts;

  return request<FleetSettingsResource>(`fleet/settings/${id}/`, {
    method: 'PATCH',
    data: sanitizedSettings,
  });
}

/**
 * Updates the fleet settings alerts
 */
export function patchAlerts(id, fleetSettingsAlerts) {
  return request(`fleet/settings/${id}/`, {
    method: 'PATCH',
    data: fleetSettingsAlerts,
  });
}

/**
 * get the dealership terms and conditions message
 */
export function termsAndConditions() {
  return request(`fleet/termsandconditions/`, {
    method: 'GET',
  });
}

/**
 * Gets the dealer charges
 */
export function charges() {
  return request<DefaultChargeResource[]>('fleet/charges/', {
    method: 'GET',
  });
}

export function requestDefaultCharges() {
  return request<DefaultChargeResource[]>('fleet/charges/defaults/', {
    method: 'GET',
  });
}

/**
 * Gets the charge by chargeId.
 */
export function charge(id: number) {
  return request<DefaultChargeResource>(`fleet/charges/${id}/`, {
    method: 'GET',
  });
}

/**
 * Saves a new charge to the database
 */
export function saveCharge(charge: DefaultChargeCreation) {
  return request<DefaultChargeResource>('fleet/charges/', {
    method: 'POST',
    data: charge,
  });
}

/**
 * Updates an existing charge by chargeId
 */
export function updateCharge(id: number, charge: DefaultChargeCreation, actingAs: number | null) {
  // only add acting_as param if provided
  const params = new URLSearchParams();
  if (actingAs) {
    params.append('acting_as', String(actingAs));
  }

  return request<DefaultChargeResource>(`fleet/charges/${id}/`, {
    method: 'PUT',
    data: charge,
    params: params,
  });
}

/**
 * Deletes a charge from the database
 */
export function deleteCharge(id: number, actingAs: number | null) {
  // only add acting_as param if provided
  const params = new URLSearchParams();
  if (actingAs) {
    params.append('acting_as', String(actingAs));
  }

  return request(`fleet/charges/${id}/`, {
    method: 'DELETE',
    params,
  });
}

/**
 * Create the dealership terms and conditions message
 */
export function postTermsAndConditions(dealershipId, name, text) {
  return request(`fleet/termsandconditions/`, {
    method: 'POST',
    data: {
      id: dealershipId,
      name,
      text,
    },
  });
}

/**
 * Update the dealership terms and conditions message
 */
export function patchTermsAndConditions(id, dealershipId, name, text) {
  return request(`fleet/termsandconditions/${id}/`, {
    method: 'PUT',
    data: {
      id,
      name,
      text,
      dealership: dealershipId,
    },
  });
}

/**
 * Gets the dealer taxes
 */
export function taxes() {
  return request('fleet/taxes/', {
    method: 'GET',
  });
}

/**
 * Saves a new tax to the database
 */
export function saveTax(tax) {
  return request('fleet/taxes/', {
    method: 'POST',
    data: tax,
  });
}

export function patchTax(tax) {
  return request(`fleet/taxes/${tax.id}/`, {
    method: 'put',
    data: tax,
  });
}

/**
 * Deletes a tax from the database
 */
export function deleteTax(id) {
  return request(`fleet/taxes/${id}/`, {
    method: 'DELETE',
  });
}

export function devices() {
  return request('fleet/devices/', {
    method: 'GET',
  });
}

export function requestDisconnectDevice(id) {
  return request(`fleet/devices/${id}/disconnect/`, {
    method: 'POST',
  });
}

export function deviceForceVin(id: number, vin: string) {
  return request<DevicesTypeResource>(`fleet/devices/${id}/force_vin/`, {
    method: 'POST',
    data: { vin },
  });
}
